import React from "react";
import { Link } from "react-router-dom";
import {
  FiHelpCircle,
  FiShield,
  FiFileText,
  FiClipboard,
  FiMapPin,
  FiCheckSquare,
} from "react-icons/fi";
import "./footer.css";
import UblLogo from "../../assets/images/ubl-logo.gif";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="footer">
      <div className="footer-content">
        {/* Container for the two columns of links */}
        <div className="links-container">
          <div className="foot-links">
            <Link to="/faq" className="foot-link" onClick={scrollToTop}>
              <FiHelpCircle /> FAQ
            </Link>
            <Link to="/privacy" className="foot-link" onClick={scrollToTop}>
              <FiShield /> Privacy Policy
            </Link>
            <Link to="/terms" className="foot-link" onClick={scrollToTop}>
              <FiFileText /> Terms & Conditions
            </Link>
          </div>

          <div className="foot-links">
            <Link to="/posterlist" className="foot-link" onClick={scrollToTop}>
              <FiCheckSquare /> Approved Poster List
            </Link>
            <Link to="/abstract" className="foot-link" onClick={scrollToTop}>
              <FiClipboard /> Abstract Submissions Guideline
            </Link>
            <Link to="/travel" className="foot-link" onClick={scrollToTop}>
              <FiMapPin /> Travel Information
            </Link>
          </div>
        </div>

        {/* UBL Pay Logo container */}
        <div className="ubl-logo-container">
          <h3 className="payment-partner">Our Payment Partner</h3>
          <img src={UblLogo} alt="UBL Pay" className="ubl-logo" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
